<template>
  <SuiteTopicsStartedBanner :suite-data="contextData" />
</template>

<script setup lang="ts">
  import type { IStartedBanner } from '@/components/Shared/Suite/TopicsStartedBanner/index.vue';

  const { t, locale } = useI18n({ useScope: 'local' });
  const { blobDomain } = useWebsite();

  const profileStore = useProfileStore();
  const { isLogin } = storeToRefs(profileStore);

  const contextData = computed((): IStartedBanner => {
    const result: IStartedBanner = {
      component: 'topics-started-banner',
      meta: {
        navigable: '',
      },
      data: {
        title: t('title'),
        description: t('description'),
        thumbnail: `${blobDomain.value}/wise-paas-marketplace/topics/doe/get-started-banner.webp`,
        items: [
          {
            name: t('item-1-title'),
            button: {
              text: t('item-1-button'),
              link: `/${locale.value}/marketplace/help/sales-support?IssueType=1`,
            },
          },
        ],
      },
    };

    if (!isLogin.value) {
      result.data.items.push({
        name: t('item-2-title'),
        button: {
          text: t('item-2-button'),
          link: '',
          hadnleClick: () => {
            profileStore.HANDLE_LOGIN();
          },
        },
      });
    }
    return result;
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Start Your Digital O&M Journey!",
    "description": "From connectivity to AI optimization—choose your path to smarter operations.",
    "item-1-title": "Talk to our experts and find the best starting point for you.",
    "item-1-button": "Contact Us",
    "item-2-title": "Access resources to accelerate your O&M transformation.",
    "item-2-button": "Create Free Account"
  },
  "en-jp": {
    "title": "Start Your Digital O&M Journey!",
    "description": "From connectivity to AI optimization—choose your path to smarter operations.",
    "item-1-title": "Talk to our experts and find the best starting point for you.",
    "item-1-button": "Contact Us",
    "item-2-title": "Access resources to accelerate your O&M transformation.",
    "item-2-button": "Create Free Account"
  },
  "en-tw": {
    "title": "Start Your Digital O&M Journey!",
    "description": "From connectivity to AI optimization—choose your path to smarter operations.",
    "item-1-title": "Talk to our experts and find the best starting point for you.",
    "item-1-button": "Contact Us",
    "item-2-title": "Access resources to accelerate your O&M transformation.",
    "item-2-button": "Create Free Account"
  },
  "en-kr": {
    "title": "Start Your Digital O&M Journey!",
    "description": "From connectivity to AI optimization—choose your path to smarter operations.",
    "item-1-title": "Talk to our experts and find the best starting point for you.",
    "item-1-button": "Contact Us",
    "item-2-title": "Access resources to accelerate your O&M transformation.",
    "item-2-button": "Create Free Account"
  },
  "en-americas": {
    "title": "Start Your Digital O&M Journey!",
    "description": "From connectivity to AI optimization—choose your path to smarter operations.",
    "item-1-title": "Talk to our experts and find the best starting point for you.",
    "item-1-button": "Contact Us",
    "item-2-title": "Access resources to accelerate your O&M transformation.",
    "item-2-button": "Create Free Account"
  },
  "en-asia-pacific": {
    "title": "Start Your Digital O&M Journey!",
    "description": "From connectivity to AI optimization—choose your path to smarter operations.",
    "item-1-title": "Talk to our experts and find the best starting point for you.",
    "item-1-button": "Contact Us",
    "item-2-title": "Access resources to accelerate your O&M transformation.",
    "item-2-button": "Create Free Account"
  },
  "en-emea": {
    "title": "Start Your Digital O&M Journey!",
    "description": "From connectivity to AI optimization—choose your path to smarter operations.",
    "item-1-title": "Talk to our experts and find the best starting point for you.",
    "item-1-button": "Contact Us",
    "item-2-title": "Access resources to accelerate your O&M transformation.",
    "item-2-button": "Create Free Account"
  },
  "ja-jp": {
    "title": "デジタルO&Mへの第一歩を踏み出しましょう",
    "description": "接続からAI最適化まで、最適な導入ステップをご提案します",
    "item-1-title": "専門家にご相談いただき、最適なスタート地点をご提案いたします",
    "item-1-button": "お問い合わせ",
    "item-2-title": "O&M変革を加速するリソースをご活用ください",
    "item-2-button": "無料アカウントを作成する"
  },
  "zh-cn": {
    "title": "Start Your Digital O&M Journey!",
    "description": "From connectivity to AI optimization—choose your path to smarter operations.",
    "item-1-title": "Talk to our experts and find the best starting point for you.",
    "item-1-button": "Contact Us",
    "item-2-title": "Access resources to accelerate your O&M transformation.",
    "item-2-button": "Create Free Account"
  },
  "zh-tw": {
    "title": "啟動您的數位維運旅程",
    "description": "從設備連接到 AI 優化，為您規劃最適合的導入路徑",
    "item-1-title": "與我們的專家深入交流，找到最適合您的起點與解決方案",
    "item-1-button": "聯絡我們",
    "item-2-title": "立即取得多元資源，加速您的維運數位轉型",
    "item-2-button": "免費建立帳號"
  }
}
</i18n>
